<header class="header">
	<nav class="navbar navbar-expand-xl navbar-light px-0 py-2 py-xl-5">
		<div class="container-fluid">
			<div class="row mx-0 w-100 justify-content-between align-items-center">
				<div class="col-auto">
					<a class="navbar-brand" [routerLink]="['/home']">
						<img src="assets/images/header/logo.svg" class="header__logo" alt="Tott Logo"></a>
				</div>
				<div class="col-auto d-xl-none">
					<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
						aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span class="navbar-toggler-icon"></span>
					</button>
				</div>
				<div class="col-xl-auto">
					<div class="collapse navbar-collapse" id="navbarNav">
						<ul class="navbar-nav py-4">
							<app-menu class="d-xl-flex align-items-xl-center"></app-menu>
						</ul>
					</div>
				</div>
				<div class="col-xl-auto d-none d-xl-block">
					<a *ngIf="!isUserLogged" [routerLink]="['/account/login']"
						class=" btn btn-primary btn-primary--small mt-4 mt-xl-0">
						Zaloguj się
					</a>
					<ul *ngIf="isUserLogged" class="navbar-nav navbar-nav--dropdown pl-6 ml-xl-auto">
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle" href="#" id="navbar-primary_dropdown_1" role="button"
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span class="dropdown-name mr-6 text--lg-weight">{{profileName}}</span>
								<img [src]="profileAvatar" class="img-fluid rounded-circle shadow-xl mr-1" width="40"
									height="50" alt="">
							</a>
							<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbar-primary_dropdown_1">
								<a class="dropdown-item" [routerLink]="['/admin/dashboard']">Profil</a>
								<div class="dropdown-divider"></div>
								<a *ngIf="!isUserLogged" [routerLink]="['/account/login']" class="dropdown-item">Zaloguj
									się</a>
								<button *ngIf="isUserLogged" (click)="logOut()" class="dropdown-item">Wyloguj
									się</button>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</nav>
</header>


<!-- <header class="header-global">
	<nav id="navbar-main"
		class="navbar fixed-top navbar-main navbar-expand-xl navbar-transparent navbar-light headroom">
		<div class="container-fluid">
			<div id="logo">
				<a [routerLink]="['/home']"><img src="assets/images/logo-white.png" alt=""></a>
			</div>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_global"
				aria-controls="navbar_global" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="navbar-collapse collapse" id="navbar_global">
				<div class="navbar-collapse-header">
					<div class="row">
						<div class="col-6 collapse-brand">
							<div id="logo">
								<a [routerLink]="['/home']"><img src="assets/images/logo-white.png" alt=""></a>
							</div>
						</div>
						<div class="col-6 collapse-close">
							<button type="butxton" class="navbar-toggler" data-toggle="collapse"
								data-target="#navbar_global" aria-controls="navbar_global" aria-expanded="false"
								aria-label="Toggle navigation">
								<span></span>
								<span></span>
							</button>
						</div>
					</div>
				</div>
				<div>
				</div>
				<ul class="navbar-nav navbar-nav-hover align-items-xl-center ml-xl-auto">
					<app-menu></app-menu>
				</ul>
				<ul *ngIf="isUserLogged" class="navbar-nav ml-xl-auto">
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle" href="#" id="navbar-primary_dropdown_1" role="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<img [src]="profileAvatar" class="img-fluid rounded-circle shadow-xl mr-1" width="40"
								height="50" alt="">
							{{profileName}}
						</a>
						<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbar-primary_dropdown_1">
							<a class="dropdown-item" [routerLink]="['/admin/dashboard']">Profil</a>
							<div class="dropdown-divider"></div>
							<a *ngIf="!isUserLogged" [routerLink]="['/account/login']" class="dropdown-item">Zaloguj
								się</a>
							<button *ngIf="isUserLogged" (click)="logOut()" class="dropdown-item">Wyloguj się</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</header> -->
